<template>
  <div class="app">
    <div
      class="left-panel"
      :class="{ collapsed: collapsed }"
    >
      <ProductList :collectionId="collectionId"></ProductList>
    </div>
    <div class="divider"></div>
    <div class="right-panel">
      <div
        class="toggle-button"
        @click="toggleCollapse"
      >
        <span v-if="collapsed">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              d="M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z"
              fill="currentColor"
            />
          </svg>
        </span>
        <span v-else>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              d="M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z"
              fill="currentColor"
            />
          </svg>
        </span>
      </div>

      <span class="head-word">
        <i class="el-icon-warning-outline"></i> Click the 'Request a Quote' button to request
        the
        engineering drawing
      </span>

      <el-button
        type="text"
        @click="centerDialogVisible = true"
        style="right: 2%;top:2%;position: absolute;"
      >Tutorial Video</el-button>

      <el-dialog
        title=""
        :visible.sync="centerDialogVisible"
        width="70%"
        top="4vh"
        center
      >
        <iframe
          width="560"
          height="315"
          style="width:100%;height: 80vh;"
          src="https://www.youtube.com/embed/az1AuvCC1H8?si=NRnPX7DriiBYJ4fx"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </el-dialog>

      <DesignPage> </DesignPage>

      <div class="add-to-cart">
        <el-statistic
          group-separator=","
          :precision="2"
          :value="price"
          style="
            font-size: 1rem;
            font-weight: 600;
            margin-bottom: 1rem;
            text-align: right;
          "
        ><template slot="prefix">Total: $</template></el-statistic>
        <el-button
          id="Btn_contactUs"
          class="cobetter_border_button button"
          @click="Fn_contactUS()"
          :disabled="contactUsDisabled"
          style="
            margin-bottom: 1rem;
          "
        >Request a Quote</el-button>
        <el-button
          type="primary"
          class="cobetter_primary_button button"
          @click="addToCart"
          :disabled="addToCartDisabled"
        >Add to Cart</el-button>
        <div style="font-weight:600;color: #D21625;text-align: right;">Price Excludes Shipping
          <el-tooltip
            placement="top"
            popper-class="tooltip-style"
          >
            <div slot="content">The price displayed includes only the item cost, the
              shipping cost willbe calculated case-by-case after final communication.</div>
            <span
              style="color:#1f427c;cursor: pointer;"
              class="iconfont iconfont-question-circle"
            ></span>
          </el-tooltip>

        </div>
      </div>
    </div>

    <el-dialog
      title="Request a Quote"
      :visible.sync="contactFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="2vh"
      style="max-height: 90vh;"
    >
      <div class="div-form">
        <el-form
          :model="contactForm"
          :rules="rules"
          ref="contactForm"
          label-position="right"
        >
          <el-form-item
            label="Your email"
            prop="email"
          >
            <el-input
              v-model="contactForm.email"
              autocomplete="off"
            ></el-input>
          </el-form-item>
           <!-- 1.管路组件 458571448619 -->
          <el-form-item
            v-if="collectionId == '458571448619' || collectionId == '458572497195' || collectionId == '458333978923'"
            label="Application"
            prop="Application"
          >
            <el-input
              type="textarea"
              v-model="contactForm.Application"
              :rows="3"
              maxlength="500"
              placeholder="Upstream process, Downstream process, Final fillling..."
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="collectionId == '458571448619' || collectionId == '458572497195' || collectionId == '458333978923' || collectionId == '450442101035'"
            label="Product Type"
            prop="ProductType"
          >
            <el-input
              type="textarea"
              v-model="contactForm.ProductType"
              :rows="2"
              maxlength="500"
              placeholder="mAb, Vaccines, ADC, Recombinant protein..."
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="collectionId == '458571448619'"
            label="Tubing Type"
            prop="TubingType"
          >
            <el-input
              type="textarea"
              v-model="contactForm.TubingType"
              :rows="2"
              maxlength="500"
              placeholder="Pt-cured silicone tubing, Pt-cured silicone pump tubing, TPE tubing..."
              show-word-limit
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="collectionId == '458571448619'"
            label="Operating Pressure"
            prop="OperatingPressure"
          >
            <el-input
              type="textarea"
              v-model="contactForm.OperatingPressure"
              :rows="2"
              maxlength="500"
              placeholder="＜1bar (14.5 psi), 1-2 bar (14.5-29 psi), ＞2bar (29 psi)..."
              show-word-limit
            ></el-input>
          </el-form-item>

          <!-- 2.储液袋组件 458572497195 -->
          <el-form-item
            v-if="collectionId == '458572497195' || collectionId == '458333978923'"
            label="Storage/Usage Temperature (°C)"
            prop="StorageUsageTemperature"
          >
            <el-input
              type="textarea"
              v-model="contactForm.StorageUsageTemperature"
              :rows="2"
              maxlength="500"
              placeholder="Room temperature, 2~8°C..."
              show-word-limit
            ></el-input>
          </el-form-item>
          <!-- 3.多联取样袋组件 458333978923 -->
          <el-form-item
            v-if="collectionId == '458333978923'"
            label="Sampling Method"
            prop="SamplingMethod"
          >
            <el-input
              type="textarea"
              v-model="contactForm.SamplingMethod"
              :rows="2"
              maxlength="500"
              placeholder="Gravity sampling, peristaltic pump sampling..."
              show-word-limit
            ></el-input>
          </el-form-item>
          
          <!-- 4.PUPSIT组件 450442101035 -->
          <el-form-item
            v-if="collectionId == '450442101035'"
            label="Development Stage"
            prop="DevelopmentStage"
          >
            <el-input
              type="textarea"
              v-model="contactForm.DevelopmentStage"
              :rows="2"
              maxlength="500"
              placeholder="Preclinical R&D, Clinical-Phase I, Clinical-Phase II"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="collectionId == '450442101035'"
            label="Dosage Form"
            prop="DosageForm"
          >
            <el-input
              type="textarea"
              v-model="contactForm.DosageForm"
              :rows="2"
              maxlength="500"
              placeholder="Water injection, Liposomes, Intraocular injection..."
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Your question"
            prop="question"
          >
            <el-input
              type="textarea"
              v-model="contactForm.question"
              :rows="7"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <img
              :src="this.$store.state.largeImgURL"
              alt=""
              id="canvasImg"
            />
          </el-form-item>
          <!-- <el-form-item>
          <el-upload
            action=""
            multiple
            :on-change="onChange"
            :on-preview="onPreview"
            :on-remove="onRemove"
            :before-remove="beforeRemove"
            :limit="3"
            :on-exceed="onExceed"
            :file-list="fileList"
            :auto-upload="false"
          >
            <el-button size="small" type="primary">upload</el-button>
          </el-upload>
        </el-form-item> -->
        </el-form>
        <div style="position: sticky;
          bottom: 10px;
          text-align: left;
          background-color: #fff;">
          <el-button
            type="primary"
            class="button cobetter_primary_button"
            @click="contactFormSubmit"
            :loading="submitLoading"
          >Send</el-button>
        </div>
      </div>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <!-- <el-button
          type="primary"
          class="button cobetter_primary_button"
          @click="contactFormSubmit"
          :loading="submitLoading"
        >Send</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import ProductList from '@/components/ProductList.vue';
  import DesignPage from '@/components/DesignPage.vue';
  import { mapState, mapMutations } from 'vuex';
  import { upload, sendEmail } from '@/api/shopify';

  export default {
    name: 'App',
    components: {
      ProductList,
      DesignPage,
    },
    data() {
      return {
        collapsed: false,
        collectionId: 0,
        price: 0,
        contactFormVisible: false,
        rules: {
          email: [{ required: true, trigger: 'blur' }],
          question: [{ required: true, trigger: 'blur' }],
          Application: [{ required: true, trigger: 'blur' }],
          ProductType: [{ required: true, trigger: 'blur' }],
          TubingType: [{ required: true, trigger: 'blur' }],
          OperatingPressure: [{ required: true, trigger: 'blur' }],
          StorageUsageTemperature: [{ required: true, trigger: 'blur' }],
          SamplingMethod: [{ required: true, trigger: 'blur' }],
          DevelopmentStage: [{ required: true, trigger: 'blur' }],
          DosageForm: [{ required: true, trigger: 'blur' }],
        },
        contactForm: {
          Application: '',
          ProductType: '',
          StorageUsageTemperature: '',
          SamplingMethod: '',
          DevelopmentStage: '',
          DosageForm: '',
          TubingType: '',
          OperatingPressure: '',
          email: '',
          question: '',
        },
        fileList: [],
        submitLoading: false,
        addToCartDisabled: true,
        contactUsDisabled: true,
        centerDialogVisible: false,
        active: 0,
      };
    },
    computed: {
      ...mapState(['selectedProductList', 'showDiv', 'renderCanvasPlus']),
    },
    watch: {
      selectedProductList: {
        handler(newVal) {
          let price = 0;
          this.addToCartDisabled = true;
          this.contactUsDisabled = true;
          newVal.forEach((element) => {
            if (element && element.selectedVariant.price) {
              this.addToCartDisabled = false;
              this.contactUsDisabled = false;
              price += Number(element.selectedVariant.price * 100); // 损失小数点精度，用整数计算
            }
          });
          this.price = price / 100;

          const newValJSON = JSON.stringify(newVal);
          // 将 JSON 字符串存储在本地存储中
          localStorage.setItem(
            'selectedProductList_' + this.collectionId,
            newValJSON
          );
        },
      },
    },
    mounted() {
      // collectionId  由html传值
      this.collectionId = parseInt(this.$route.query.collectionId);
      let firstIn = localStorage.getItem('firstIn');
      if (!firstIn) {
        this.centerDialogVisible = true;
        localStorage.setItem('firstIn', 1);
      }

      let spl = JSON.parse(
        localStorage.getItem('selectedProductList_' + this.collectionId)
      );
      if (spl) {
        this.setSelectedProductList(spl);
      }
    },
    created() {},
    methods: {
      ...mapMutations(['setSelectedProductList']),
      next() {
        if (this.active++ > 2) this.active = 0;
      },
      pre() {
        if (this.active-- < 2) this.active = 0;
      },
      contactFormSubmit() {
        this.$refs['contactForm'].validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            // 下面的代码将创建一个空的FormData对象:
            let formData = new FormData();
            // FormData.append来添加键/值对到表单里面；
            this.fileList.forEach((file) => {
              formData.append('file[]', file.raw);
            });

            // 添加自定义参数
            formData.append('email', this.contactForm.email);
            formData.append('question', this.contactForm.question);
            formData.append('Application', this.contactForm.Application);
            formData.append('ProductType', this.contactForm.ProductType);
            formData.append('TubingType', this.contactForm.TubingType);
            formData.append('OperatingPressure', this.contactForm.OperatingPressure);
            formData.append('StorageUsageTemperature', this.contactForm.StorageUsageTemperature);
            formData.append('SamplingMethod', this.contactForm.SamplingMethod);
            formData.append('DevelopmentStage', this.contactForm.DevelopmentStage);
            formData.append('DosageForm', this.contactForm.DosageForm);

            let blobStr = this.dataURLtoBlob(this.$store.state.largeImgURL);
            formData.append('imagePath', blobStr);
            let productList = this.getProductsStr();
            formData.append('products', productList);

            await sendEmail(formData)
              .then((res) => {
                if (res.code == 200001) {
                  this.$message.success('Email delivered.');
                } else {
                  this.$message({
                    showClose: true,
                    message: 'failed!',
                    type: 'error',
                  });
                }
                //清空fileList
                this.fileList = [];
                this.contactForm.Application = '';
                this.contactForm.ProductType = '';
                this.contactForm.TubingType = '';
                this.contactForm.OperatingPressure = '';
                this.contactForm.StorageUsageTemperature = '';
                this.contactForm.SamplingMethod = '';
                this.contactForm.DevelopmentStage = '';
                this.contactForm.DosageForm = '';
                this.contactForm.email = '';
                this.contactForm.question = '';
              })
              .catch(function (e) {});
            this.submitLoading = false;
            this.contactFormVisible = false;
          } else {
            return false;
          }
        });
      },
      addToCart() {
        // 将选中的变体信息编码为 URL 参数
        const queryParams = this.selectedProductList
          .map((variant) => {
            if (variant && 'selectedVariant' in variant) {
              return `${variant.selectedVariant.id},1`;
            }
            // 如果不满足条件，则返回 undefined，该项会被忽略
          })
          .filter((queryParam) => queryParam !== undefined) // 过滤掉 undefined 值
          .join('|');

        // 构建 Shopify 商城页面的 URL，将编码后的参数添加到 URL 中
        const shopifyURL = `https://cobetter-4573.myshopify.com/cart?variantIds=${queryParams}`;
        // const shopifyURL = `test?variantIds=${queryParams}`;

        window.open(shopifyURL);
      },
      //文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
      onChange(file) {
        this.fileList.push(file);
      },
      //文件列表移除文件时的钩子
      onRemove(file) {
        const index = this.fileList.indexOf(file);
        if (index !== -1) {
          this.fileList.splice(index, 1);
        }
      },
      //点击文件列表中已上传的文件时的钩子
      onPreview(file) {},
      //文件超出个数限制时的钩子
      onExceed(files) {
        this.$message.warning(`Limit the selection of up to 3 files`);
      },
      //删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除。
      beforeRemove(file) {
        return this.$confirm(`remove ${file.name}？`);
      },
      toggleCollapse() {
        this.collapsed = !this.collapsed;
      },
      Fn_contactUS() {
        this.$store.state.canvasFunction(); //借助vuex调用designPage组件里的函数
        setTimeout(() => {
          this.$store.state.canvasFunction();
        }, 10);
        this.contactFormVisible = true;
      },
      //base64转二进制函数
      // base64ToBinary(base64Url) {
      //   var data = base64Url.split(',')[1];
      //   var binaryString = window.atob(data);
      //   var length = binaryString.length;
      //   var bytes = new Uint8Array(length);
      //   for (var i = 0; i < length; i++) {
      //     bytes[i] = binaryString.charCodeAt(i);
      //   }
      //   return bytes;
      // },
      base64ToBinary(base64Url) {
        var data = base64Url.split(',')[1];
        var binaryString = window.atob(data);
        var length = binaryString.length;
        var binaryResult = '';
        for (var i = 0; i < length; i++) {
          var charCode = binaryString.charCodeAt(i);
          var binary = charCode.toString(2);
          binaryResult += binary.padStart(8, '0');
        }
        return binaryResult;
        // return binaryString
      },
      dataURLtoBlob(dataurl) {
        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {
          type: mime,
        });
      },
      getProductsStr() {
        var temp = [];
        this.selectedProductList.forEach((item, index) => {
          if (item) {
            temp[index] = item.title + ' - ' + item.selectedVariant.title;
          }
        });
        return temp;
      },
    },
  };
</script>

<style>
  .app {
    display: flex;
    height: 100vh;
    overflow: hidden; /* 隐藏整个页面的滚动条 */
    border-left: 1px solid #cfcfcf;
    border-right: 1px solid #cfcfcf;
  }

  .left-panel {
    width: 22rem;
    background-color: #fff;
    transition: width 0.5s;
  }

  .left-panel.collapsed {
    max-width: 22rem;
    width: 0rem;
    padding-right: 1.5rem;
  }

  .divider {
    border-right: 1px solid #dfdfdf;
    height: 100%;
    left: 0;
    transform: translateX(-50%);
  }

  .toggle-button {
    text-align: center;
    background-color: #fff;
    border: 1px solid #dfdfdf;
    cursor: pointer;
    padding: 8px 8px 4px;
    border-radius: 50%;
    position: absolute;
    top: 1rem;
    transform: translateX(-50%);
    z-index: 999;
  }

  .right-panel {
    flex: 1;
    width: 70%;
    height: 80%;
    padding-top: 2rem;
    background-color: #fff;
    text-align: center;
  }

  .el-card__body {
    padding: 0px !important;
  }

  .el-dialog {
  }

  .el-statistic .con .prefix {
    font-size: 1.5rem;
  }

  .el-statistic .con .number {
    margin-left: -6px;
    font-size: 1.5rem;
    letter-spacing: -0.9px;
  }

  .add-to-cart {
    float: right;
    margin-top: 1rem;
    margin-right: 5%;
  }

  .head-word {
    margin-right: 40%;
    font-size: 14px;
  }

  @media screen and (max-width: 1366px) {
    .head-word {
      margin-right: 15%;
    }
  }

  #canvasImg {
    width: 100%;
    border: 1px solid #dfdfdf;
  }

  .el-dialog__body {
    padding: 0px 0px;
  }

  .div-form {
    margin: 0px 20px;
  }

  .el-card {
    border: 0;
  }

  .tooltip-style.el-tooltip__popper {
    background: #1f427c;
    max-width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Custom.vue